// Extrait verbatim de src/components/Sidebar.js (découpe iso du 06/09/2026).
import { LayoutDashboard, ListChecks, Calendar, FolderTree, Mail, BarChart3, Ticket, FlaskConical, Monitor, Disc3, PackageOpen, Printer, Radio, Droplets, Database, Link2, Share2, Building, Users, Shield, DollarSign, Phone, Cloud, RefreshCw, FileText, TrendingUp, Sparkles, Package, ShoppingCart, Activity, Bell, Send, Cpu, BookOpen, GitBranch, Target, Clock, Settings, GraduationCap, MessageSquare, Lightbulb, StickyNote, Globe, UserCheck, PhoneIncoming, FolderOpen, ShieldAlert, Lock, Radar, Container, ArrowRightLeft, Server, LayoutTemplate, Star, Zap, Smartphone, Bug, Box, Terminal, Globe2, Search, Workflow, HardDrive, Layers, Hourglass, Tag, Code, History, ClipboardList, ClipboardCheck, FileSignature, Bot, Calculator } from 'lucide-react';
import { isUserInternalForOrg } from '../../lib/roles';

const sidebarCategories = [
  {
    id: 'portail', label: 'PORTAIL', defaultOpen: true,
    items: [
      // Accueil de pilotage : le dirigeant (drapeau `est_dirigeant` du serveur) voit SON accueil à la place de
      // l'accueil commun ; tous les autres comptes gardent l'accueil commun.
      { path: '/pilotage', label: 'Accueil', icon: LayoutDashboard, permission: 'dashboard.view', dirigeant: true },
      { path: '/dashboard', label: 'Accueil', icon: LayoutDashboard, permission: 'dashboard.view', saufDirigeant: true },
      { path: '/ma-journee', label: 'Ma journée', icon: ListChecks, permission: 'dashboard.view' },
      // Espace du salarié, pas du RH : `hr.leave.request` est accordée à
      // tous les rôles internes et ne donne accès à AUCUNE donnée RH.
      { path: '/mes-conges', label: 'Mes congés', icon: Calendar, permission: 'hr.leave.request' },
      // Superadmin only : la permission classement.view n'est accordée qu'à ce
      // rôle, l'entrée disparaît donc d'elle-même pour tous les autres.
      { path: '/classement', label: 'Classement', icon: FolderTree, permission: 'classement.view' },
      // Meme doctrine : superadmin STRICT (ces boites recoivent du courrier
      // de n'importe qui, et le corps d'un mail est du texte non fiable).
      { path: '/mails', label: 'Mails', icon: Mail, permission: 'mails.view' },
      // Pages des boucles d'agents (mails, antivirus) : superadmin STRICT, comme /mails.
      { path: '/pages-ia', label: 'Pages agents', icon: LayoutTemplate, permission: 'pages_ia.view' },
      // Pages partagées avec les techniciens (#20852) : chacun n'y voit QUE les pages qui le concernent (filtre serveur).
      { path: '/pages-partagees', label: 'Pages partagées', icon: ClipboardCheck, permission: 'ticketing.view' },
    ],
  },
  {
    id: 'ticketing', label: 'TICKETING', defaultOpen: true,
    items: [
      { path: '/ticketing/dashboard', label: 'TDB Ticketing', icon: BarChart3, permission: 'ticketing.view' },
      { path: '/tickets', label: 'Tickets', icon: Ticket, permission: 'ticketing.view' },
      // Internes seulement (spec § 6) : un client ou un prestataire externe porte ticketing.view (`internes`, ci-dessous).
      { path: '/maia/attente', label: 'Maia attend', icon: Bot, permission: 'ticketing.view', internes: true, badge: 'maia' },
      { path: '/tickets/analytics', label: 'Analytics', icon: BarChart3, permission: 'ticketing.reporting' },
      { path: '/laboratoire', label: 'Laboratoire', icon: FlaskConical, permission: 'ticketing.view' },
    ],
  },
  {
    id: 'parc', label: 'PARC',
    items: [
      { path: '/parc/ordinateurs', label: 'Ordinateurs', icon: Monitor, permission: 'parc.view' },
      // Vue Serveurs (#20580) : serveurs Windows, NAS (version DSM relevée par l'agent), hyperviseurs.
      { path: '/parc/serveurs', label: 'Serveurs', icon: Server, permission: 'parc.view' },
      // Pilotage du serveur d'imaging FOG (capture / restauration d'images) : droit `fog.view`, géré côté serveur.
      { path: '/parc/masterisation', label: 'Masterisation', icon: Disc3, permission: 'fog.view' },
      { path: '/parc/logiciels', label: 'Logiciels', icon: PackageOpen, permission: 'parc.view' },
      { path: '/parc/imprimantes', label: 'Imprimantes', icon: Printer, permission: 'parc.view' },
      { path: '/parc/sondes', label: 'Sondes', icon: Radio, permission: 'parc.view' },
      { path: '/parc/toners', label: 'Toners', icon: Droplets, permission: 'parc.toners.view' },
      { path: '/parc/sauvegardes', label: 'Sauvegardes', icon: Database, permission: 'parc.view' },
      { path: '/parc/meteris-backup', label: 'Meteris Backup', icon: HardDrive, permission: 'parc.view' },
      { path: '/parc/liaisons', label: 'Liaisons & Affectations', icon: Link2, permission: 'parc.view' },
      { path: '/parc/mesh', label: 'LAN virtuels', icon: Share2, permission: 'mesh.manage' },
    ],
  },
  {
    id: 'gestion', label: 'CLIENTS & UTILISATEURS',
    items: [
      { path: '/gestion/societes', label: 'Sociétés', icon: Building, permission: 'ticketing.manage' },
      { path: '/gestion/utilisateurs', label: 'Utilisateurs', icon: Users, permission: 'ticketing.manage' },
      { path: '/eset-licenses', label: 'Licences ESET', icon: Shield, permission: 'eset.manage' },
    ],
  },
  {
    id: 'comptabilite', label: 'COMPTABILITÉ',
    items: [
      { path: '/gestion/facturation', label: 'Facturation', icon: DollarSign, permission: 'billing.view' },
      { path: '/parc/toners/facturation', label: 'Facturation copies', icon: DollarSign, permission: 'parc.toners.view' },
      { path: '/gestion/telephonie', label: 'Telephonie VoIP', icon: Phone, permissions: ['billing.view', 'settings.manage'] },
      { path: '/also/billing', label: 'Licences ALSO', icon: Cloud, permission: 'also.view' },
      { path: '/also/licences', label: 'Gestion licences', icon: Cloud, permission: 'also.view' },
      { path: '/also/admin', label: 'ALSO Administration', icon: Cloud, permission: 'also.admin' },
      { path: '/amc/billing', label: 'Facturation AMC', icon: DollarSign, permission: 'amc_billing.view' },
      { path: '/gestion/rapprochements-auto', label: 'Rapprochements bancaires', icon: RefreshCw, permission: 'accounting.reconcile' },
      { path: '/gestion/tiers', label: 'Tiers & règlements', icon: Users, permission: 'accounting.reconcile' },
      { path: '/comptabilite/banque', label: 'Banque (multi-soc)', icon: FileText, permission: 'accounting.bank.view' },
      { path: '/comptabilite/previsionnel', label: 'Prévisionnel', icon: TrendingUp, permission: 'accounting.forecast.view' },
    ],
  },
  {
    // Toute la section n'existe que dans l'organisation SCI Les Tilleuls, superadmin compris.
    id: 'meet-meaux', label: 'MEETMEAUX', orgs: ['SCI'],
    items: [
      { path: '/gestion/meet-meaux/reservations', label: 'Réservations salles', icon: Sparkles, permission: 'meet-meaux.manage' },
      // Organisation SCI Les Tilleuls (enseigne MeetMeaux) : section `meet-meaux` de enabled_modules.
      // `orgs` : n'existe QUE dans l'organisation SCI Les Tilleuls, superadmin compris
      // (le superadmin voit toutes les SECTIONS quelle que soit l'org ; cette entrée-ci non).
      { path: '/gestion/meet-meaux/etats-des-lieux', label: 'États des lieux', icon: ClipboardCheck, role: 'superadmin', orgs: ['SCI'] },
      // Convention de mise à disposition de salle, signée en ligne (spec convention-signature) : même règle.
      { path: '/gestion/meet-meaux/conventions', label: 'Conventions', icon: FileSignature, role: 'superadmin', orgs: ['SCI'] },
    ],
  },
  {
    id: 'catalogue', label: 'CATALOGUE',
    items: [
      { path: '/gestion/produits', label: 'Base Produits', icon: Package, permission: 'ticketing.manage' },
      // `crm.manage` : aligné sur le gate backend d'émission de devis (18/08/2026).
      { path: '/gestion/panier', label: 'Panier / Devis', icon: ShoppingCart, permission: 'crm.manage', badge: 'cart' },
      { path: '/gestion/catalogue/import', label: 'Import (fournisseurs)', icon: ShoppingCart, permission: 'ticketing.manage' },
      { path: '/admin/catalog-suppliers', label: 'Imports auto fournisseurs', icon: Activity, permission: 'ticketing.manage' },
      { path: '/admin/catalog-price-anomalies', label: 'Anomalies prix', icon: Bell, permission: 'ticketing.manage' },
      { path: '/gestion/catalogue/alertes-prix', label: 'Alertes prix', icon: Bell, permission: 'stock.manage' },
      { path: '/gestion/catalogue/revue', label: 'Revue catalogue', icon: ShoppingCart, permission: 'catalog.review', badge: 'unknown_attrs' },
      { path: '/gestion/tarification', label: 'Tarification', icon: DollarSign, permission: 'pricing.manage' },
      { path: '/gestion/stock', label: 'Stock', icon: Package, permission: 'stock.manage' },
      { path: '/gestion/rfq', label: 'Demandes de Prix', icon: Send, permission: 'rfq.manage' },
      { path: '/admin/pc-configs', label: 'Configurations PC', icon: Cpu, permission: 'settings.manage' },
      // « Options service PC » retirée (fusion 2026-08-05) : les options de
      // devis s'éditent sur la fiche produit (Base Produits, case Option de devis).
    ],
  },
  {
    id: 'kb', label: 'BASE DE CONNAISSANCES',
    items: [
      { path: '/kb', label: 'Articles', icon: BookOpen, permission: 'kb.view' },
      { path: '/kb/assist', label: 'Assistant IA', icon: Sparkles, permission: 'kb.view' },
      { path: '/kb/categories', label: 'Catégories', icon: FolderTree, permission: 'kb.view' },
    ],
  },
  {
    id: 'crm', label: 'CRM',
    items: [
      { path: '/crm', label: 'TDB CRM', icon: BarChart3, permission: 'crm.view' },
      { path: '/crm/pipeline', label: 'Pipeline', icon: GitBranch, permission: 'crm.view' },
      { path: '/crm/deals', label: 'Opportunités (liste)', icon: Target, permission: 'crm.view' },
      { path: '/crm/quotes', label: 'Devis', icon: FileText, permission: 'crm.view' },
      // Coûts, marges et montants des clients : superadmin STRICT, comme la route et l'API.
      { path: '/crm/calculateur-contrats', label: 'Calculateur de contrats', icon: Calculator, role: 'superadmin' },
      { path: '/crm/contacts', label: 'Contacts', icon: Users, permission: 'crm.view' },
      // « Comptes » supprimée 2026-08-05 — la société est celle du ticketing
      // (Gestion > Sociétés), il n'y a plus de référentiel société propre au CRM.
      { path: '/crm/activities', label: 'Activités', icon: Clock, permission: 'crm.view' },
      // /crm/leads supprimée 2026-05-12 — les leads sont au stage "Nouveau Lead" du pipeline
      { path: '/crm/settings', label: 'Configuration', icon: Settings, permission: 'crm.admin' },
    ],
  },
  {
    id: 'formation', label: 'FORMATION MCF',
    items: [
      { path: '/mcf/formations', label: 'Formations', icon: GraduationCap, permission: 'mcf.formation.view' },
      { path: '/mcf/inscriptions', label: 'Groupage inscriptions', icon: Users, permission: 'mcf.inscription.view' },
      { path: '/mcf/ateliers', label: 'Ateliers & Coaching', icon: Sparkles, permission: 'mcf.formation.view' },
      { path: '/mcf/learners', label: 'Stagiaires', icon: Users, permission: 'qb.learner.view' },
      { path: '/mcf/sessions', label: 'Sessions', icon: Calendar, permission: 'qb.session.view' },
      { path: '/mcf/bpf', label: 'BPF (bilan pédago/fin)', icon: FileText, permission: 'mcf.bpf.view' },
      { path: '/mcf/banque', label: 'Banque (journal asso)', icon: FileText, permission: 'mcf.bank.view' },
      { path: '/mcf/admin/sync', label: 'Sync Qualiobee', icon: RefreshCw, permission: 'qb.sync.view' },
    ],
  },
  {
    id: 'assistant', label: 'ASSISTANT',
    items: [
      { path: '/assistant', label: 'TDB Assistant', icon: MessageSquare, permission: 'assistant.view' },
      { path: '/calendar', label: 'Calendrier', icon: Calendar, permission: 'calendar.view' },
      { path: '/assistant/prospects', label: 'Prospects', icon: Users, permission: 'assistant.view' },
      { path: '/assistant/ideas', label: 'Idées', icon: Lightbulb, permission: 'assistant.view' },
      { path: '/assistant/appointments', label: 'Rendez-vous', icon: Calendar, permission: 'assistant.view' },
      { path: '/assistant/notes', label: 'Notes', icon: StickyNote, permission: 'assistant.view' },
      { path: '/assistant/kb-drafts', label: 'KB Brouillons', icon: BookOpen, permission: 'assistant.view' },
    ],
  },
  {
    id: 'outils', label: 'OUTILS',
    items: [
      { path: '/sites', label: 'Sites', icon: Globe, permission: 'sites.view' },
      { path: '/bi', label: "Bon d'Intervention", icon: FileText, permission: 'bi.view' },
      { path: '/reception', label: 'Réception Client', icon: UserCheck, permission: 'reception.view' },
      { path: '/rendez-vous-comptoir', label: 'RDV atelier', icon: Calendar, permission: 'it_bookings.view' },
      { path: '/configurateur-admin', label: 'Configurateur RDV', icon: GitBranch, permission: 'it_bookings.manage' },
      { path: '/messagerie', label: 'Messagerie vocale', icon: Phone, permission: 'voicemails.view' },
      { path: '/call-history', label: 'Historique appels', icon: PhoneIncoming, permission: 'voicemails.view' },
      { path: '/downloads', label: 'Téléchargements', icon: FolderOpen, permission: 'downloads.view' },
    ],
  },
  {
    id: 'microsoft365', label: 'MICROSOFT 365',
    items: [
      { path: '/microsoft365', label: 'Tenants clients', icon: Cloud, permission: 'm365.view' },
    ],
  },
  {
    id: 'incidents', label: 'INCIDENTS',
    items: [
      { path: '/incidents', label: 'Incidents', icon: ShieldAlert, permission: 'incidents.view' },
    ],
  },
  {
    id: 'securite', label: 'SÉCURITÉ',
    items: [
      { path: '/vault', label: 'Coffre-fort', icon: Lock, permission: 'vault.view' },
    ],
  },
  {
    id: 'rapports', label: 'RAPPORTS',
    items: [
      { path: '/reports', label: 'Rapports', icon: BarChart3, permission: 'reports.view' },
      { path: '/reports/activity', label: "Rapport d'activité", icon: TrendingUp, role: 'superadmin' },
      // Superadmin STRICT (V1) : mandats SEPA signés en ligne, IBAN des clients.
      { path: '/admin/signature', label: 'Signature électronique', icon: FileText, role: 'superadmin' },
      { path: '/reports/technician-time', label: 'Temps Techniciens', icon: Clock, role: 'superadmin' },
      { path: '/reports/questions-teams', label: 'Questions Teams', icon: MessageSquare, role: 'superadmin' },
      // Registre des constats techniciens : SUPERADMIN STRICT (spec registre-constats).
      { path: '/gestion/constats', label: 'Constats techniciens', icon: ClipboardList, role: 'superadmin' },
      { path: '/reports/my-interventions', label: 'Mes Interventions', icon: Clock, hideForRole: 'superadmin' },
    ],
  },
  {
    id: 'veille', label: 'VEILLE',
    items: [
      { path: '/veille', label: 'Veille stratégique', icon: Radar, permission: 'veille.view' },
    ],
  },
  {
    id: 'social', label: 'RÉSEAUX SOCIAUX',
    items: [
      { path: '/social', label: 'TDB Réseaux sociaux', icon: Share2, permission: 'social.view' },
      { path: '/social/posts', label: 'Liste des articles', icon: FileText, permission: 'social.view' },
      { path: '/social/calendar', label: 'Calendrier éditorial', icon: Calendar, permission: 'social.view' },
      { path: '/social/planning', label: 'Planning annuel', icon: BarChart3, permission: 'social.view' },
    ],
  },
  {
    id: 'docker', label: 'DOCKER',
    items: [
      { path: '/admin/docker', label: 'Serveurs', icon: Container, permission: 'docker.manage' },
      { path: '/admin/docker/migrate', label: 'Migrations', icon: ArrowRightLeft, permission: 'docker.manage' },
    ],
  },
  {
    id: 'vmware', label: 'VMWARE',
    items: [
      { path: '/admin/vmware', label: 'Hôtes ESXi', icon: Server, permission: 'vmware.manage' },
      { path: '/admin/vmware/vms', label: 'Machines Virtuelles', icon: Monitor, permission: 'vmware.manage' },
      { path: '/admin/vmware/migrate', label: 'Migrations', icon: ArrowRightLeft, permission: 'vmware.manage' },
      { path: '/admin/vmware/pra', label: 'Plans PRA', icon: Shield, permission: 'vmware.manage' },
    ],
  },
  {
    id: 'proxmox', label: 'PROXMOX',
    items: [
      { path: '/admin/proxmox', label: 'Clusters', icon: Server, permission: 'proxmox.manage' },
      { path: '/admin/proxmox/vms', label: 'VMs & Conteneurs', icon: Cpu, permission: 'proxmox.manage' },
      { path: '/admin/proxmox/migrate', label: 'Migrations', icon: ArrowRightLeft, permission: 'proxmox.manage' },
      { path: '/admin/proxmox/pra', label: 'Plans PRA', icon: Shield, permission: 'proxmox.manage' },
    ],
  },
  {
    id: 'configuration', label: 'CONFIGURATION',
    items: [
      { path: '/settings', label: 'Paramètres', icon: Settings, permissions: ['settings.manage', 'users.manage', 'downloads.manage', 'backup.settings'] },
      { path: '/gestion/groupes', label: 'Groupes', icon: Users, permission: 'ticketing.admin' },
      { path: '/configuration/modeles', label: 'Modèles', icon: LayoutTemplate, permission: 'settings.manage' },
      { path: '/configuration/categories', label: 'Catégories', icon: FolderTree, permission: 'settings.manage' },
      { path: '/configuration/favoris', label: 'Favoris (filtres)', icon: Star, permission: 'ticketing.view' },
      { path: '/configuration/snippets', label: 'Raccourcis texte', icon: Zap, permission: 'settings.manage' },
      { path: '/admin/configuration/imprimantes', label: 'Imprimantes', icon: Printer, permission: 'admin.printers' },
      { path: '/admin/sms', label: 'Passerelle SMS', icon: MessageSquare, permission: 'scheduled_tasks.manage' },
      { path: '/admin/configuration/my-meteris', label: 'Déploiement MyMeteris', icon: Smartphone, permission: 'admin.mobile_deploy', role: 'superadmin' },
      { path: '/admin/bug-reports', label: 'Bugs portail', icon: Bug, permission: 'admin.bug_reports' },
    ],
  },
  {
    id: 'inventaire', label: 'INVENTAIRE',
    items: [
      { path: '/parc/inventaire', label: 'TDB Inventaire', icon: Box, permission: 'inventory.view' },
      { path: '/admin/agent-scripts', label: 'Scripts Agent', icon: Terminal, permission: 'agent.execute' },
      { path: '/admin/agent-groups', label: 'Groupes Agent', icon: Users, permission: 'agent.execute' },
      { path: '/admin/agent-campaigns', label: 'Campagnes', icon: Send, permission: 'agent.execute' },
      { path: '/admin/agent-install-status', label: 'Statut Agents (GLPI legacy)', icon: Activity, permission: 'agent.execute' },
      { path: '/admin/meteris-agents', label: 'Agents Meteris (V1 unifié)', icon: Server, permission: 'agent.execute' },
      { path: '/admin/agents/versions', label: "Versions de l'agent", icon: GitBranch, role: 'superadmin' },
      { path: '/admin/agents/heure', label: 'Heure des postes', icon: Clock, permission: 'parc.view' },
      { path: '/admin/agents/sans-societe', label: 'Postes sans société', icon: Building, role: 'superadmin' },
      { path: '/admin/deploiement-agent', label: 'Déploiement agent', icon: Send, permission: 'agent.execute' },
      { path: '/admin/snmp', label: 'SNMP Discovery', icon: Radio, permission: 'snmp.manage' },
    ],
  },
  {
    id: 'rh', label: 'RH',
    items: [
      { path: '/rh/registre', label: 'Registre du personnel', icon: Users, permission: 'hr.view' },
      { path: '/rh/pointage', label: 'Pointage & paie', icon: Clock, permission: 'hr.attendance.view' },
    ],
  },
  {
    id: 'admin', label: 'ADMINISTRATION',
    items: [
      { path: '/gestion/domaines', label: 'Domaines', icon: Globe2, permission: 'ticketing.manage' },
      { path: '/gestion/cloudflare-zones', label: 'Zones Cloudflare', icon: Globe2, permission: 'cloudflare.view' },
      { path: '/documents', label: 'Documents', icon: FileText, permission: 'documents.view' },
      { path: '/admin/system-monitor', label: 'Monitoring Système', icon: Activity, permission: 'system.monitor' },
      { path: '/admin/e2e-monitor', label: 'Monitoring E2E', icon: Activity, permission: 'settings.manage' },
      { path: '/admin/seo', label: 'Monitoring SEO', icon: Search, permission: 'seo.view' },
      { path: '/admin/ai-usage', label: 'Monitoring IA', icon: Cpu, permission: 'system.monitor' },
      { path: '/n8n', label: 'Workflows n8n', icon: Workflow, permission: 'n8n.manage' },
      { path: '/email-triage', label: 'Email Triage', icon: Mail, permission: 'n8n.manage' },
      { path: '/admin/scheduled-tasks', label: 'Tâches planifiées', icon: Clock, permission: 'scheduled_tasks.manage' },
      { path: '/admin/notification-digests', label: 'Digests notifications', icon: Bell, permission: 'ticketing.admin' },
      { path: '/admin/procedures', label: 'Procédures', icon: ListChecks, permission: 'procedures.view' },
      { path: '/admin/procedures/dashboard', label: 'Procédures · Dashboard', icon: BarChart3, permission: 'procedures.view' },
      { path: '/admin/backups', label: 'Sauvegardes', icon: HardDrive, permission: 'settings.manage' },
      { path: '/admin/qualiobee-backups', label: 'Sauvegardes Qualiobee', icon: HardDrive, permission: 'superadmin' },
      { path: '/admin/spooler', label: "File d'attente", icon: Send, permission: 'spooler.manage' },
      { path: '/admin/rules', label: 'Règles métier', icon: Zap, permission: 'spooler.manage' },
      { path: '/admin/eset-task-actions', label: 'ESET — Catalogue d\'actions', icon: Shield, permission: 'eset.admin' },
      { path: '/admin/eset-classification', label: 'ESET — Classification', icon: Layers, permission: 'eset.admin' },
      { path: '/admin/eset/trials', label: 'ESET — Trials', icon: Hourglass, permission: 'eset.admin' },
      { path: '/admin/banque/mappings', label: 'Banque — Mappings IBAN', icon: Database, permission: 'accounting.bank.admin' },
      { path: '/admin/banque/categories', label: 'Banque — Règles catégorisation', icon: Tag, permission: 'accounting.bank.admin' },
      { path: '/admin/banque/parsers', label: 'Banque — Parsers', icon: Code, permission: 'accounting.bank.admin' },
      // Journal général : superadmins seulement (12/10/2026) — il rend tout, sociétés réservées comprises.
      { path: '/activity', label: 'Historique', icon: History, permission: 'superadmin' },
    ],
  },
];

// Entrée réservée à certaines organisations (codes canoniques, ex. 'SCI') : visible
// seulement si l'organisation ACTIVE en fait partie — jamais en mode « toutes ».
export function itemVisibleDansOrg(item, codeOrgActive) {
  if (!item || !Array.isArray(item.orgs) || item.orgs.length === 0) return true;
  return Boolean(codeOrgActive) && item.orgs.includes(String(codeOrgActive).toUpperCase());
}

// Section visible dans l'organisation active. Une section qui porte `orgs` n'existe
// QUE dans ces organisations, superadmin COMPRIS (décision William 27/09 : MEETMEAUX
// n'apparaît que dans la SCI). Sinon, règle historique : le superadmin voit toutes
// les sections ; les autres, celles des modules activés de l'org (aucun = toutes).
export function sectionVisibleDansOrg(cat, { isSuperadmin, activeOrg }) {
  if (!itemVisibleDansOrg(cat, activeOrg?.code)) return false;
  if (isSuperadmin) return true;
  if (!activeOrg?.enabled_modules?.length) return true;
  return activeOrg.enabled_modules.includes(cat.id);
}

// Entrée réservée aux comptes INTERNES (`internes: true`) : ni client, ni prestataire externe (`is_external`) — rôle
// effectif dans l'organisation active, comme partout (`isUserInternalForOrg`). Aucune permission ne peut l'exprimer : un
// prestataire porte les permissions de son rôle interne (fiche des droits, piège 15). « Maia attend » (#20550, 10/10).
export function itemVisiblePourCompte(item, user, codeOrgActive) {
  if (!item) return true;
  const dirigeant = Boolean(user && user.est_dirigeant === true);
  if (item.dirigeant && !dirigeant) return false;
  if (item.saufDirigeant && dirigeant) return false;
  if (!item.internes) return true;
  return isUserInternalForOrg(user, codeOrgActive);
}

export default sidebarCategories;
